import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { SearchPersonVM } from 'shell/components/shared/sipo-person-form/new-person';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface SearchPersonProps {
  values?: SearchPersonVM;
  resetForm: () => void;
  onChange: (key: keyof SearchPersonVM, value: SearchPersonVM[keyof SearchPersonVM]) => void;
  onSearch: () => void;
}

const SearchPersonComponent = ({
  values,
  onChange,
  resetForm,
  onSearch,
}: SearchPersonProps): React.ReactElement => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          id="fiscalCode"
          fullWidth
          onChange={(event) => {
            onChange('fiscalCode', event?.target.value);
          }}
          value={values?.fiscalCode?.toUpperCase() || ''}
          inputProps={{ maxLength: '16' }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          onChange={(event) => {
            onChange('surname', event?.target.value);
          }}
          value={values?.surname || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurname"
              checked={values?.withoutSurname || false}
              onChange={() => onChange('withoutSurname', !values?.withoutSurname)}
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          onChange={(event) => {
            onChange('name', event?.target.value);
          }}
          value={values?.name || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutName"
              checked={values?.withoutName || false}
              onChange={() => onChange('withoutName', !values?.withoutName)}
              inputProps={{ 'aria-label': 'Persona senza nome' }}
            />
          }
          label="Persona senza nome"
        />
      </Grid>
      <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center' }}>
        <PmiButton color="cdmBrandThird" variant="outlined" fullWidth onClick={onSearch}>
          Cerca
        </PmiButton>
      </Grid>
      <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center' }}>
        <PmiButton variant="outlined" color="cdmBrand" fullWidth onClick={resetForm}>
          Pulisci
        </PmiButton>
      </Grid>
    </Grid>
  );
};

SearchPersonComponent.displayName = 'Search Person component';

const SearchPerson = memo(SearchPersonComponent);

export default SearchPerson;
